import { c as _c } from "react/compiler-runtime";
import { ServicingPanel } from "@/sanity/sanity.types";
import PortableTextRenderer from "../utils/PortableTextRenderer";
import ContactInfo from "../utils/ContactInfo";
import LinkRenderer from "../utils/LinkRenderer";
interface ServicingPanelSectionProps {
  data: ServicingPanel;
}
const ServicingPanelSection = t0 => {
  const $ = _c(10);
  const {
    data
  } = t0;
  let t1;
  if ($[0] !== data.body) {
    t1 = data.body && <PortableTextRenderer content={data.body} />;
    $[0] = data.body;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== data.links) {
    t2 = data.links && data.links.length > 0 && <div className="mt-6 mb-8 flex flex-col gap-2">{data.links.map(_temp)}</div>;
    $[2] = data.links;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== data.contactCard) {
    t3 = data.contactCard && <div className="rounded-md border border-[#e5eaf4] bg-[#f6f6f6] p-8">{data.contactCard.title && <p className="mb-4 text-lg leading-6 font-semibold text-[#1b2a2f]">{data.contactCard.title}</p>}<ContactInfo phone={data.contactCard.phone} email={data.contactCard.email} /></div>;
    $[4] = data.contactCard;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <>{t1}{t2}{t3}</>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default ServicingPanelSection;
function _temp(link) {
  return <LinkRenderer key={link._key} link={link} />;
}